import React,{useState} from 'react'

import { useFormik } from 'formik'
import * as Yup from "yup"
import {useHistory} from "react-router-dom"
import { gql, useMutation } from '@apollo/client'


const SINGIN = gql`
    mutation singin($input: Credentials) {
  singin(input: $input) {
    token
  }
}
`

const Login = () => {
    const [mensaje,guardarMensaje] = useState(null)
    const history = useHistory()
    const [singin] = useMutation(SINGIN)
   
    const mostrarMensaje = ( ) => {
        return(
            <div className=" px-3 w-full text-gray-200 py-10 font-bold text-2xl max-w-sm text-center mx-auto">
                <p>{mensaje}</p>
            </div>
        )    
    }

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        }, 
        validationSchema: Yup.object({
            email: Yup.string()
                        .email('El email no es válido')
                        .required('El email no puede ir vacio'),
            password: Yup.string()
                        .required('El password es obligatorio')
        }), 
        onSubmit: async valores => {
           
            const { email, password } = valores;
            try{
                const {data} = await singin({
                    variables: {
                           input:{
                               email,
                               password
                           }
                    }
                })
        
                guardarMensaje('Autenticando...')

                //Guardar el token en localstorage
                const {token} = data.singin
                localStorage.setItem("token",token)
                setTimeout(() => {
                    guardarMensaje(null)
                    history.push('/user')
                    history.go()
                } ,200)

                //Enviar hacia clientes
        }catch(error){
        guardarMensaje(error.message.replace("GraphQL error: ", ""));

        setTimeout(() => {
            guardarMensaje(null)
           
        } ,2000)
        }  
        }
    })
  

  return (
    <div className='h-screen bg-gray-800'>
          {mensaje && mostrarMensaje()}
        <h1 className="text-center pt-2  text-2xl text-white font-light">Login</h1>

       
        <div className="flex justify-center mt-5">
            <div className="w-full max-w-sm">
                <form
                    className="bg-white rounded shadow-md px-8 pt-6 pb-8 mb-4"
                    onSubmit={formik.handleSubmit}
                >
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                            Email
                        </label>

                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="email"
                            type="email"
                            placeholder="Email Usuario"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                        />
                    </div>

                    { formik.touched.email && formik.errors.email ? (
                        <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" >
                            <p className="font-bold">Error</p>
                            <p>{formik.errors.email}</p>
                        </div>
                    ) : null  }

                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                            Password
                        </label>

                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="password"
                            type="password"
                            placeholder="Password Usuario"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.password}
                        />
                    </div>

                    { formik.touched.password && formik.errors.password ? (
                        <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" >
                            <p className="font-bold">Error</p>
                            <p>{formik.errors.password}</p>
                        </div>
                    ) : null  }

                    <input
                        type="submit"
                        className="bg-gray-800 w-full mt-5 p-2 text-white uppercas hover:cursor-pointer hover:bg-gray-900"
                        value="Iniciar Sesión"
                    />
                    <div className='flex'>
                        <div className='w-7/12'>  </div>
                    
                  
                   
                    </div>
                
                    

                </form>
            </div>
        </div>
    
</div>

  )
}

export default Login